export default __webpack_public_path__ + "static/media/Fiche Reflechi.fb0d12c4.pdf";